import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function ContainerOverviewCrumb({ current }: CrumbTemplateProps) {
  return (
    <Crumb
      current={current}
      path={Routing.stock.containers.overview()}
      text={t(TranslationKey.container).plural.upper}
    />
  );
}
